import { render } from "./AdminTerminal.vue?vue&type=template&id=16c9cede&scoped=true"
import script from "./AdminTerminal.vue?vue&type=script&lang=js"
export * from "./AdminTerminal.vue?vue&type=script&lang=js"

import "./AdminTerminal.vue?vue&type=style&index=0&id=16c9cede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c9cede"]])

export default __exports__